import OpenBetSettings from '@/modules/integrations/types/openbet/OpenBetSettings.vue'
import OpenBetOverview from '@/modules/integrations/types/openbet/OpenBetOverview.vue'

export default Object.freeze({
  type: 'openbet',
  title: 'Integrations_OpenBet',
  category: 'Integrations_OpenBet_Category',
  description: 'Integrations_OpenBet_Description',
  image: require('@/img/integrations/openbet.png'),
  requiresAdmin: false,
  disableSaveButton: true,
  requiresApproval: true,
  components: {
    settings: OpenBetSettings,
    overview: OpenBetOverview
  },
  urls: {}
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/openbet/index.js